import { AuthActions } from '@/components/molecules/auth/AuthActions'
import { HomeHeader } from '@/components/molecules/header-simple/HomeHeader'
import { PromiseBlock } from '@/components/molecules/step-you-are/PromiseBlock'
import { VisionRadar } from '@/components/molecules/vision-radar/VisionRadar'

export function HomeLanding() {
	return (
		<div className="flex h-screen flex-col justify-between py-8">
			<HomeHeader />
			<PromiseBlock />
			<VisionRadar value={86} label="VISIÓN" className="mt-2 mb-6" />
			<AuthActions />
		</div>
	)
}
